import React from 'react';
import { TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { showMedicalContentSelector } from '@/redux/config/selfData';

/**
 * サービス種別に応じた翻訳を返す。
 * Medicalでは `${key}_med` を優先し、既存の `${key}_medical` にも対応する。
 * それ以外では通常の `${key}` を参照する。
 */
export const useServiceTranslation = () => {
  const { t, i18n, ready } = useTranslation();
  const showMedicalContent = useSelector(showMedicalContentSelector);

  const serviceT = React.useCallback(
    (key: string, options: TOptions = {}) => {
      const context = showMedicalContent
        ? i18n.exists(`${key}_med`, { ...options, context: undefined }) ? 'med' : 'medical'
        : undefined;

      return t(key, {
        ...options,
        context,
      });
    },
    [showMedicalContent, t, i18n],
  );

  return { t, i18n, ready, serviceT };
};
